import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "caret",
  "use": "caret-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 10 10\" id=\"caret\"><g clip-path=\"url(#caret_a)\"><path fill=\"currentColor\" d=\"M5.327 6.717a.5.5 0 0 1-.654 0l-2.99-2.589a.5.5 0 0 1 .328-.878h5.978a.5.5 0 0 1 .327.878z\" /></g><defs><clipPath id=\"caret_a\"><path fill=\"currentColor\" d=\"M0 0h10v10H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol